import { LegalLayout } from "@/components/LegalLayout";
import { CONTACT_EMAIL } from "@/constants/site";

export default function Refund() {
  const email = <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;
  return (
    <LegalLayout
      testId="refund-page"
      title="Coins & Refund Policy"
      updated="June 1, 2026"
      intro="Aura Live uses an in-app virtual currency called “coins”. This policy explains how coins are purchased, spent and refunded, and how host earnings and cash-outs work."
    >
      <h2>How coins work</h2>
      <p>
        Coins are Aura Live's in-app virtual currency. You buy coins to send
        animated gifts and tips to hosts during their live streams. Coins have no
        monetary value outside the Application and, for hosts, no value until an
        approved cash-out is processed.
      </p>

      <h2>Purchases</h2>
      <p>
        All coin purchases are processed exclusively through <strong>Apple In-App
        Purchase</strong> or <strong>Google Play Billing</strong>. We never see or
        store your card or bank details. The price shown at checkout, in your local
        currency and inclusive of any applicable taxes, is the amount charged by
        Apple or Google.
      </p>

      <h2>Refunds</h2>
      <p>
        Because purchases are handled by the app stores, <strong>Apple's and
        Google's payment terms and refund policies govern all refund matters. We
        cannot issue direct refunds for coin purchases.</strong> To request a
        refund for a coin purchase, please file the request with the store you
        bought from:
      </p>
      <ul>
        <li><strong>Apple App Store:</strong> visit reportaproblem.apple.com and sign in with your Apple ID.</li>
        <li><strong>Google Play:</strong> use the Google Play Store order history or play.google.com/store/account.</li>
      </ul>
      <p>
        Nothing in this policy limits any statutory refund or withdrawal rights you
        may have under applicable consumer protection law that cannot be lawfully
        excluded.
      </p>

      <h2>Gifts & tips are final</h2>
      <p>
        Coins spent on gifts or tips sent to hosts are <strong>final and
        non-refundable</strong> once sent, except where required by law. Please
        make sure you intend to send a gift before confirming it.
      </p>

      <h2>Chargebacks</h2>
      <p>
        If a coin purchase is charged back through Apple, Google or a card issuer,
        we may deduct the corresponding coins (including any coins already spent on
        gifts or tips) from any user's balance and, where necessary, suspend the
        account involved.
      </p>

      <h2>Host earnings & cash-outs</h2>
      <p>Hosts accumulate coins from the gifts and tips they receive. Cash-outs are subject to:</p>
      <ul>
        <li>A minimum cash-out threshold.</li>
        <li>Identity verification (KYC) and applicable tax reporting.</li>
        <li>A fraud-review period of up to 30 days before funds are released.</li>
      </ul>
      <p>
        Hosts who cash out are responsible for any income, VAT or other tax
        obligations in their jurisdiction. We may collect tax information and issue
        tax forms where required.
      </p>

      <h2>Expiry & inactivity</h2>
      <p>
        Coins are not transferable between users outside the gift and tip features,
        are not redeemable for cash except through the cash-out process, and expire
        if your account is inactive for 24 consecutive months.
      </p>

      <h2>Questions</h2>
      <p>
        For any questions about coins, gifts, tips or cash-outs, contact us at{" "}
        {email}. For refunds of a specific purchase, please contact Apple or Google
        as described above.
      </p>
    </LegalLayout>
  );
}
